import { render, staticRenderFns } from "./SOSLite.vue?vue&type=template&id=212ed167&scoped=true"
import script from "./SOSLite.vue?vue&type=script&lang=js"
export * from "./SOSLite.vue?vue&type=script&lang=js"
import style0 from "./SOSLite.vue?vue&type=style&index=0&id=212ed167&prod&scoped=true&lang=css"
import style1 from "./SOSLite.vue?vue&type=style&index=1&id=212ed167&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ed167",
  null
  
)

export default component.exports